import { EnderecoDTO } from "./enderecoDTO";

export class PromotoraDTO {
  public matriz!: string;
  public nomeMatriz!: string;
  public id!: string | null;
  public ativo!: boolean;
  public nome!: string;
  public cnpj!: string;
  public email!: string;
  public cidade!: string;
  public enderecoDTO!: EnderecoDTO | undefined;
  public telefoneComercial!: string;
  public telefoneCelular!: string;
  public gerenteResponsavel!: string;
  public valorMeta!: number | string;
  public codigoExterno!: string;
  public nConsultas !: number | string;
  public promotoraAquisicao !:  boolean;
  public idOriginador? : number | string | null;
  public nomeOriginador?: string;
  public idsOriginadores?: Array<number | string>;
  public nomesOriginadores?: string;

  codigoBanco?: string;
  nomeBanco?: string;
  agencia?: string;
  conta?: string;
  digitoConta?: string;
  tipoConta?: string;
  camaraCentralizadora?: string;
  chavePix?: string;
}
